.CloseButton {
  align-items: center;
  color: currentcolor;
  display: flex;
  margin-left: auto;
  text-decoration: none;

  & svg {
    height: var(--icon-size-md);
    width: var(--icon-size-md);
  }
}

.AlertContent {
  align-items: center;
  display: flex;
  gap: var(--space-xs);

  & .Icon {
    width: var(--icon-size-sm);
  }
}

.AlertMsg {
  margin-right: var(--space-3xl);
}

.Alert {
  align-items: center;
  animation: fade-in 500ms linear 0s 1 normal forwards;
  animation-play-state: running;
  border: 1px solid transparent;
  border-left-width: var(--space-md);
  border-radius: var(--border-radius-sm);
  display: flex;
  flex-direction: row;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  padding: var(--space-md);
  position: relative;

  &::first-letter {
    text-transform: capitalize;
  }

  &.success {
    background-color: var(
      --background-surface-foundation-background-success-light
    );
    border-color: var(--border-foundation-border-success);
    color: var(--border-foundation-border-success);

    & p {
      color: var(--content-foundation-content-success);
    }
  }

  &.error {
    background-color: var(
      --background-surface-foundation-background-danger-light
    );
    border-color: var(--border-foundation-border-danger);
    color: var(--border-foundation-border-danger);

    & p {
      color: var(--content-foundation-content-danger);
    }
  }

  &.warning {
    background-color: var(--background-surface-core-background-warning-light);
    border-color: var(--border-foundation-border-warning);
    color: var(--content-foundation-content-warning);

    & p {
      color: var(--content-foundation-content-warning);
    }
  }

  &.information {
    background-color: var(--background-surface-core-background-accent-a-light);
    border-color: var(--border-foundation-border-accent-a);
    color: var(--content-foundation-content-accent-a);

    & p {
      color: var(--content-foundation-content-accent-a);
    }
  }

  &.floating {
    animation: fade-in-floating 500ms linear 0s 1 normal forwards;
    border-bottom-left-radius: var(--border-radius-sm);
    border-bottom-right-radius: var(--border-radius-sm);
    border-top-left-radius: 0;
    display: none;
    position: fixed;
    right: 0;
    transition: all 0.3s;
    width: 0;
    z-index: calc(var(--z-index-modal-overlay) + 1);

    @media (--md-devices) {
      display: flex;
      left: 210px;
      top: 0;
      width: calc(100% - 210px);
    }

    &.success {
      background-color: var(--color-green-100);
    }

    &.error {
      background-color: var(--color-red-200);
    }

    &.warning {
      background-color: var(--color-orange-200);
    }

    &.menuIsCollapsed {
      display: flex;
      left: 0;
      top: 47px;
      width: 100%;

      @media (--md-devices) {
        left: 59px;
        width: calc(100% - 59px);
      }
    }
  }
}

/* Dark mode: the default borders are bright solid hues while the fills are
   faint alpha tints, so the outline reads as one of the palest, loudest things
   on the page. Soften each border to the alpha-50 variant of its own hue — same
   color family as the alpha-25 fill, so the differentiation is minimal. */
html[data-color-mode='dark'] .Alert {
  &.success {
    border-color: var(--border-core-border-success-light);
  }

  &.error {
    border-color: var(--border-core-border-danger-light);
  }

  &.warning {
    border-color: var(--border-core-border-warning-light);
  }

  &.information {
    border-color: var(--mint-alpha-50);
  }
}

@keyframes fade-in {
  from {
    opacity: 0%;
  }

  to {
    opacity: 100%;
  }
}

@keyframes fade-in-floating {
  from {
    opacity: 0%;
    transform: translateY(-100%);
  }

  to {
    opacity: 100%;
    transform: translateX(0);
  }
}
